import React, { Component, useRef } from 'react';
import styled from 'styled-components';
import Head from 'next/head';
import Axios from 'axios';
import sanitizeHtml from 'sanitize-html';
import { SiteAPI, WordPressAPI } from '../config';
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';

const BasicContent = styled.section`
  p {
    font-weight: 400;
    &.title {
      text-align: center;
      text-transform: capitalize;
      font-size: 2rem;
      margin-bottom: 1em;
      strong {
        font-weight: 300;
      }
    }
  }
`;

const privacyPolicy = ({ data }) => {

  // Handles the scrolling on table of contents
  const handleClick = (id) => {
    const headerOffset = 60;
    const section = document.querySelector(`#${id}`)
    const bodyRect = document.body.getBoundingClientRect().top;
    const sectionPosition = section.getBoundingClientRect().top;
    const elementPosition = sectionPosition - bodyRect;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  return (
    <div>
      <SEOHead>
        <title>Privacy Policy</title>
        <meta key="description" name="description" content="Learn more about how we protect your data and keep your information private, according to state and federal laws." />
      </SEOHead>
      <Header
        PaidCampaign={1}
        phone_number={{
          online_phone_number: '18002226868',
          offline_phone_number: '18002226868',
          office_hours: {
            start_time: '09:00',
            end_time: '19:30',
          }
        }}
      />
      <BasicContent>
        {data.privacy_policy_sections.map((section, index) => {
          return index === 0 ?
            <div className="container" id={`section-${index + 1}`}>
              <p><strong>{section.heading}</strong></p>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(section.text_content, {
                    allowedTags: sanitizeHtml.defaults.allowedTags,
                  }),
                }}
              />
              <p><strong>TABLE OF CONTENTS</strong></p>
              <p>
                {data.table_of_contents.map((section, index) =>
                  <>
                    <a href={`#${section.section}`} onClick={() => handleClick(`section-${index + 2}`)}>
                      {section.section}
                    </a>
                    <br />
                  </>
                )}
              </p>
            </div>
            :

            <div className="container" id={`section-${index + 1}`}>
              <p><strong>{section.heading}</strong></p>
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(section.text_content, {
                    allowedTags: sanitizeHtml.defaults.allowedTags,
                  }),
                }}
              />
            </div>

        })}
      </BasicContent>
      <FooterComponent />
    </div>
  );
}

export const getStaticProps = async () => {
  const { data } = await Axios.get(`${WordPressAPI.pages}/173`);
  return {
    props: {
      data: data.acf,
    },
    // revalidate: 1,
  };
};

export default privacyPolicy;
